const documentPaths = {
  'privacy-policy': 'privacy',
  'terms-of-service': 'terms',
  'user-agreement': 'disclaimer',
  'cookie-policy': 'cookie',
  'refund-policy': 'refund',
  'data-processing-agreement': 'dpa'
};

export const getLandingDocumentUrl = (landingUrl, documentType) => {
  if (!landingUrl || !documentType) return null;
  const type = documentType.toLowerCase().replace(/_/g, '-');
  return `/landing/${encodeURIComponent(landingUrl)}/${documentPaths[type] || type}`;
};
